import { render, staticRenderFns } from "./DiceControl.vue?vue&type=template&id=6993e99e&scoped=true"
import script from "./DiceControl.vue?vue&type=script&lang=js"
export * from "./DiceControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6993e99e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6993e99e')) {
      api.createRecord('6993e99e', component.options)
    } else {
      api.reload('6993e99e', component.options)
    }
    module.hot.accept("./DiceControl.vue?vue&type=template&id=6993e99e&scoped=true", function () {
      api.rerender('6993e99e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/controls/DiceControl.vue"
export default component.exports